//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PSI',
  data () {
    return {
      defaultJson: {
        'Age': '年龄',
        'Nursing Home Resident': '居住在养老院',

        'Neoplastic Disease': '肿瘤',
        'Liver Disease': '肝脏疾病',
        'Congestive Heart Failure': '充血性心力衰竭',
        'Cerebrovascular Disease': '脑血管疾病',
        'Renal Disease': '肾脏疾病',

        'Altered Mental Status': '意识状态改变',
        'Respiratory Rate ≥ 30/min': '呼吸频率 ≥ 30次/分',
        'SBP < 90mmHg': '收缩压 < 90 mmHg',
        'Temperature < 35 or ≥ 40°C': '体温 < 35℃或 ≥ 40℃',
        'Pulse ≥ 125/min': '脉搏 ≥ 125次/分',

        'Arterial pH < 7.35': '动脉血pH < 7.35',
        'Blood urea nitrogen ≥ 11mmol/L': '血尿素氮 ≥ 11mmol/L',
        'Na < 120 mmol/L': '血钠 < 120 mmol/L',
        'Glucose > 14 mmol/L': '血糖 > 14 mmol/L',
        'Hematocrit < 30 %': '红细胞压积 < 30%',
        'PaO₂ || SaO₂': 'PaO₂ < 60 mmHg(或SaO₂ < 90%)',

        'Pleural Effusion': '存在胸腔积液',

        'Class I': 'I 类',
        'Class II': 'II 类',
        'Class III': 'III 类',
        'Class IV': 'IV 类',
        'Class V': 'V 类',
      },
      form: {
        age: '',
        gender: '1',
        nursing: '0',

        neuDx: '0',
        liverDx: '0',
        chf: '0',
        neoDx: '0',
        renalDx: '0',

        mental: '0',
        rr: '0',
        sbp: '0',
        temp: '0',
        pulse: '0',

        ph: '0',
        bun: '0',
        na: '0',
        glu: '0',
        htc: '0',
        po2: '0',

        pleural: '0',

        // urea_bun: '',
        // urea_urea: ''
      },
      hasScore: false,
      disabled: false,
      dataList2: [{ value: '1', name: '男' }, { value: '0', name: '女' }],
      dataList3: [
        { value: 'urea_bun', name: 'BUN' },
        { value: 'urea_urea', name: '尿素' }
      ],
      urea: 'urea_bun',
      activeIndex: 0,
      mortality: '--',
      descTxt: '',
      bun_value: ''
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (self.urea == 'urea_bun') {
        form['urea_urea'] = '0'
      } else {
        form['urea_bun'] = '0'
      }
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.mortality = '--'
        return '--'
      } else {
        let result = 0
        let mortality = 0
        // (1 == urea) ? urea_urea * 2.8 : urea_bun
        let bun_value =
          self.urea == 'urea_urea' ? form.urea_urea * 2.8 : form.urea_bun

        // age + (gender.isFemale ? -10 : 0) + (nursing ? 10 : 0) + (neuDx ? 30 : 0) + (liverDx ? 20 : 0) + (chf ? 10 : 0) + (neuDx ? 10 : 0) + (renalDx ? 10 : 0) +		(mental ? 20 : 0) + (rr ? 20 : 0) +	(sbp ? 20 : 0) + (temp ? 15 : 0) +		(pulse ? 10 : 0) + (ph ? 30 : 0) + (bun_value >= 30 ? 20 : 0) +	(na ? 20 : 0) +	(glu >= 250 ? 10 : 0) +	(htc ? 10 : 0) + (po2 < 60 ? 10 : 0) + (pleural ? 10 : 0)

        result =
          form.age +
          (form.gender == 0 ? -10 : 0) +
          (form.nursing ? 10 : 0) +
          (form.neoDx ? 30 : 0) +
          (form.liverDx ? 20 : 0) +
          (form.chf ? 10 : 0) +
          (form.neuDx ? 10 : 0) +
          (form.renalDx ? 10 : 0) +
          (form.mental ? 20 : 0) +
          (form.rr ? 20 : 0) +
          (form.sbp ? 20 : 0) +
          (form.temp ? 15 : 0) +
          (form.pulse ? 10 : 0) +
          (form.ph ? 30 : 0) +
          (form.bun ? 20 : 0) +
          (form.na ? 20 : 0) +
          (form.glu ? 10 : 0) +
          (form.htc ? 10 : 0) +
          (form.po2 ? 10 : 0) +
          (form.pleural ? 10 : 0)

        if (result < 50) {
          self.descTxt = 'I 级'
        } else if (result <= 70) {
          self.descTxt = 'II 级'
        } else if (result <= 90) {
          self.descTxt = 'III 级'
        } else if (result <= 130) {
          self.descTxt = 'IV 级'
        } else {
          self.descTxt = 'V 级'
        }

        let obj = {
          0: 0.1,
          50: 0.6,
          70: 0.9,
          90: 9.3,
          130: 27
        }
        let arr = [130, 90, 70, 50, 0]
        for (let i = 0; i < arr.length; i++) {
          if (result >= arr[i]) {
            mortality = obj[arr[i]]
            break
          }
        }

        self.mortality = String(mortality.toFixed(2))

        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PSI.vue